import React from 'react';
import PropTypes from 'prop-types';

import './style.css';

const getIDP = (authId) => {
  if(authId.startsWith('google')) {
    return 'Google Account';
  } else if(authId.startsWith('facebook')) {
    return 'Facebook Account';
  }
}

export const Profile = ({userinfo: { firstName, lastName, email, authId }}) => {

  let login = '';

  if(getIDP(authId)) {
    login = (<p styleName="detail"><span>Login</span><br />{getIDP(authId)}</p>);
  }

  return (
    <div styleName="profile">
      <p styleName="detail"><span>Name</span><br />{firstName} {lastName}</p>
      <p styleName="detail"><span>Email</span><br />{email}</p>
      {login}
    </div>
  );
};

Profile.propTypes = {
  userinfo: PropTypes.shape({
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    authId: PropTypes.string.isRequired,
  }).isRequired,
};

export default Profile;



// WEBPACK FOOTER //
// ./web/flows/account/components/Profile/component.js